// extracted by css-extract-rspack-plugin
export default {"label":"ic4A86mQDhwJ7E6K"};